module.exports = __webpack_public_path__ + "static/img_5047-da46c3afc06f0e31edf7963127224ec3.webp";